module.exports = __webpack_public_path__ + "img/kiosk-pc-clean.9134ed14.png";